<template>
  <v-card :loading="isLoading" :disabled="isLoading">
    <v-card-title>
      <v-row justify="space-between">
        <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.auctionBid') }}</span>
        <v-btn icon @click.stop="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </v-card-title>
    <v-form v-model="isFormValid" ref="bidForm" autocomplete="off" @submit.prevent="">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <label>{{ $t('label.enterOfferForAuction') }}</label>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="bid.bid"
              :label="$t('label.price') + ' (' + auction.currencyType.code + ')'"
              :rules="[rules.required, rules.offerPrice, rules.maxPrice(bid.bid, auction.basePrice)]"
              prepend-inner-icon="mdi-currency-usd"
              outlined
              dense>
            </v-text-field>
          </v-col>
          <v-col cols="12">
            {{ $t('label.currentPrice') }}: <strong>${{ auction.currentPrice }} {{ auction.currencyType.code }}</strong>
            <br>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small depressed @click.stop="cancel" :disabled="isLoading">{{ $t('label.cancel') }}</v-btn>
        <v-btn small depressed @click.stop="isConfirmationBidDialogOpen = true" color="primary" :loading="isLoading" :disabled="!isFormValid">{{ $t('label.sendOffer') }}</v-btn>
      </v-card-actions>
    </v-form>
    <v-dialog v-model="isConfirmationBidDialogOpen" max-width="500" persistent>
      <confirmation-dialog @confirm="confirmationBid">
        <span v-html="$t('message.confirmation.createOffer', [bid.bid, auction.currencyType.code])"></span>
      </confirmation-dialog>
    </v-dialog>
  </v-card>
</template>

<script>
import { loading, rules, showMessage } from '../../../mixins'
import ConfirmationDialog from '../../Shared/ConfirmationDialog'

export default {
  name: 'AuctionBid',
  components: { ConfirmationDialog },
  mixins: [loading, rules, showMessage],
  props: {
    auctionId: Number,
    isActive: Boolean
  },
  data: () => ({
    isFormValid: null,
    isConfirmationBidDialogOpen: false,
    auction: {
      currencyType: {
        code: '-'
      }
    },
    bid: {}
  }),
  methods: {
    getAuction () {
      this.changeLoadingStatus(true)
      this.$proxy.get(`api/auctions/${this.auctionId}`)
        .then((r) => {
          this.auction = r.data
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    },
    confirmationBid (confirm) {
      this.isConfirmationBidDialogOpen = false
      if (confirm) {
        this.bidAuction()
      }
    },
    bidAuction () {
      this.changeLoadingStatus(true)
      this.bid.auctionId = this.auctionId
      this.$proxy.post('api/auctions/bid', this.bid)
        .then((r) => {
          this.showMessage(this.$t('message.success.offerSaved'))
          this.$emit('saved')
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    },
    cancel () {
      this.clearForm()
      this.$emit('cancel')
    },
    clearForm () {
      this.auction = {
        currencyType: {
          code: '-'
        }
      }
      this.bid = {}
      this.$refs.bidForm.resetValidation()
    }
  },
  watch: {
    auctionId: function (newVal, oldVal) {
      if (!this.isActive) {
        return
      }
      if (newVal) {
        this.clearForm()
        this.getAuction()
      }
    }
  },
  mounted () {
    this.getAuction()
  }
}
</script>

<style>

</style>
